import * as React from "react";
import { useEffect, useState } from "react";

import {
  DataGrid,
  gridPageCountSelector,
  GridToolbar,
  gridPageSelector,
  GridToolbarContainer,
  GridToolbarExport,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";

import { customerService } from "../../services/customer.service";
import {
  GetCustomerVoucherAtom,
  SetCustomerVoucherAtom,
} from "../../store/CustomerVoucherAtom";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";






const columns = [

  {
    title: "Ref No",
    dataIndex: "Ref_No",
    sorter: (a, b) => (a?.Ref_No ?? '') - (b?.Ref_No ?? '')

  },  
    
  
  {
    title: "Transaction Date",
    dataIndex: "Transaction_Date",
    sorter: (a, b) => (a?.Transaction_Date ?? '').localeCompare(b?.Transaction_Date ?? '')

  },

  {
    title: "Voucher Number",
    dataIndex: "Voucher_Number",
    sorter: (a, b) => (a?.Voucher_Number ?? '') - (b?.Voucher_Number ?? '')
  },

  {
    title: "Amount",
    dataIndex: "Voucher_Amount",
    sorter: (a, b) => (a?.Voucher_Amount ?? '') - (b?.Voucher_Amount ?? '')
  },

  {
    title: "Recipient_Name",
    dataIndex: "Reciepient_Name",
    sorter: (a, b) => (a?.Reciepient_Name ?? '').localeCompare(b?.Reciepient_Name ?? '')

  },
  {
    title: "Recipient Number",
    dataIndex: "Reciepient_Mobile_Number",
    sorter: (a, b) => (a?.Reciepient_Mobile_Number ?? '').localeCompare(b?.Reciepient_Mobile_Number ?? '')
  },
 
  {
    title: "Status",
    dataIndex: "Voucher_Status_Name",
    sorter: (a, b) => (a?.Voucher_Status_Name ?? '').localeCompare(b?.Voucher_Status_Name ?? '')
  },
 
];


export default function VoucherTab({ customer_id }) {
  const [tableList, setTableList] = useState([]);
  const setVoucherList = SetCustomerVoucherAtom();
  const voucherList = GetCustomerVoucherAtom();





  useEffect(()=> {
    getDataFromServer();

  },[customer_id]);

  const getDataFromServer = () => {
    let isMounted = true;
    customerService.getCustomerVouchers(customer_id).then((res) => {
      if (isMounted && res.data?.length) {
        let tempList = res.data.map((item) => {
          return { ...item, id: item?.Ref_No, Transaction_Date: formatCustomDate(item?.Transaction_Date), 
             Voucher_Amount: formatCustomNumber(item?.Voucher_Amount)} }
        );
        setVoucherList(tempList);
        setTableList(tempList);
      }else if (isMounted) {
        setVoucherList([]);
        setTableList([]);
      }
    });
    return () => {
      isMounted = false;
    };
  };

  // function OnItemCellClick(event) {
  //   const id = event.row['Invoice_Ref_No'];
  //   navigate(`/${currModuleId}/${currModuleName}/invoices/details/${id}`);
  // }

  return (
    <>
      <div className="ml-1 @container">
        <div className="mt-1 text-gray-600 text-xl font-bold">Voucher List</div>


<section className="mt-5">
      <GeneralCustomTable
                        tableHeadList={columns} 
                        tableDataList={tableList}
                        allowCheckBox={false} // show checkBox for each row
                        // setSelectedRows={selectCustomer}
                        rowKey={(record) => record.Ref_No} // custom key
                        handleRowClick={()=> console.log('cki') }
                         />
                     </section>
      </div>
    </>
  );
}
